import { useEffect, useState } from "react";
import Grid, { GridColumn, GridHeader, GridRow } from "../Grid/Grid";
import { Card } from "react-bootstrap";
import EquipmentPreviewBlade from "./EquipmentPreviewBlade";
import { Eye, EyeFill } from "react-bootstrap-icons";
import EquipmentTaskListBlade from "./EquipmentTaskListBlade";
import { Button } from "../Button/Button";
import AllEquipmentTaskListBlade from "./AllEquipmentTaskListBlade";

interface propData {
    data: any;
    code: string;
    otherData: any;
}

const headers: GridHeader[] = [
    {
        title: "",
        class: 'text-center',
    },
    {
        title: "Manufacturer",
        class: 'text-center',
    },
    {
        title: "Model",
        class: 'text-center'
    },
    {
        title: "Serial #",
        class: 'text-center'
    },
    {
        title: "Location",
        class: 'text-center'
    },
    {
        title: "System",
        class: 'text-center'
    },
    {
        title: "Unit",
        class: 'text-center'
    }
];

const QuoteDetailEquiment = (props: propData) => {
    const [rows, setRows] = useState<GridRow[]>([]);
    const [showModal, setShowModal] = useState(false)
    const [selectedData, setSelectedData] = useState<any>()
    const [showTasklistModel, setShowTasklistModel] = useState(false);
    const [selectedEquipment, setSelectedEquipment] = useState('');
    const [tasklistType, setTasklistType] = useState('');
    const [allEquipmentData, setAllEquipmentData] = useState([]);
    const [isShowAllTasklistBlade, setShowAllTasklistBlade] = useState(false);

    useEffect(() => {
        getEquipments()
    }, [])

    const getEquipments = () => {
        if (props.data.equipment && props.data.equipment.length > 0) {
            setAllEquipmentData(props.data.equipment)
            let rows: GridRow[] = [];
            for (var i in props.data.equipment) {
                let columns: GridColumn[] = [];
                columns.push({ value: renderImage(props.data.equipment[i]) });
                columns.push({ value: props.data.equipment[i].manufacturer });
                columns.push({ value: props.data.equipment[i].modelNum });
                columns.push({ value: props.data.equipment[i].serialNum });
                columns.push({ value: props.data.equipment[i].eqpLoc });
                columns.push({ value: props.data.equipment[i].system });
                columns.push({ value: props.data.equipment[i].unitNum });
               // columns.push({ value: action(props.data.equipment[i]) });
                rows.push({ data: columns, type: 'A', backgroundColor: props.data.equipment[i].bg, textColor: props.data.equipment[i].tc });

                let columns2: GridColumn[] = [];
                columns2.push({ value: props.data.equipment[i].descr });
                rows.push({ data: columns2, type: 'B', backgroundColor: props.data.equipment[i].bg, textColor: props.data.equipment[i].tc });
            }
            setRows(rows);
        }
    }

    const renderImage = (data: any) => {
        return (
            <img src={data.eqpUrl} height={60} width={60} style={{ width: '100%' }} onClick={() => {
                setSelectedData(data.eqpUrl)
                setShowModal(true)
            }} />
        )
    }

    const action = (data: any) => {
        return (
            <>
                <div onClick={() => {
                    setSelectedEquipment(data)
                    setShowTasklistModel(true)
                }} className='cursor-pointer'>
                    <EyeFill />
                </div>
            </>
        )
    }

    const onCloseModal = () => {
        setShowModal(false)
    }

    return (
        <>
            {showTasklistModel && <EquipmentTaskListBlade
                isShow={showTasklistModel}
                isClose={() => {
                    setShowTasklistModel(false)
                    setTasklistType('')
                }}
                data={props.data}
                code={props.code}
                id={selectedEquipment}
                type={tasklistType}
                otherData={props.otherData}
            />}
            
            <EquipmentPreviewBlade
                isShow={showModal}
                isClose={onCloseModal}
                data={selectedData}
            />
            <Card className="card-style form-style invoice-call-picture-card p-3" style={{ marginBottom: 50 }}>
                <Grid
                    headers={headers}
                    rows={rows} />
            </Card>
        </>
    )
}

export default QuoteDetailEquiment;